export const BusinessIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M54.6485 12.0399H41.213L40.5472 7.46838C40.2559 5.46916 38.5127 3.96143 36.4924 3.96143H23.5077C21.4873
      3.96143 19.7441 5.46916 19.4529 7.46861L18.7871 12.0399H5.3516C2.4007 12.0399 0 14.4406 0 17.3913V50.6869C0 53.6378 2.4007
      56.0385 5.3516 56.0385H54.6485C57.5993 56.0385 60 53.6378 60 50.6869V17.3913C60 14.4406 57.5993 12.0399 54.6485 12.0399ZM22.9455
      7.97721C22.9859 7.69994 23.2276 7.49088 23.5078 7.49088H36.4925C36.7727 7.49088 37.0145 7.70006 37.0548 7.97721L37.6465
       12.0399H22.3539L22.9455 7.97721ZM56.4707 50.687C56.4707 51.6917 55.6533 52.5092 54.6485 52.5092H5.3516C4.34684 52.5092
       3.52934 51.6918 3.52934 50.6869V33.8652C5.0823 35.0785 7.03359 35.8042 9.15258 35.8042H22.9409V37.5297C22.9409 38.1815
       23.3 38.7802 23.8751 39.0867L29.1695 41.9103C29.4291 42.0487 29.7144 42.1179 30 42.1179C30.2855 42.1179 30.5709 42.0488
       30.8305 41.9103L36.1249 39.0867C36.7 38.7801 37.0591 38.1815 37.0591 37.5297V35.8043H50.8474C52.9663 35.8043 54.9177
       35.0786 56.4707 33.8653V50.687ZM26.4703 36.4709V31.373H33.5298V36.4709L30 38.3534L26.4703 36.4709ZM56.4707 26.6516C56.4707
        29.7523 53.9481 32.2749 50.8474 32.2749H37.0591V29.6081C37.0591 28.6336 36.2691 27.8434 35.2944 27.8434H24.7056C23.7311
        27.8434 22.9409 28.6335 22.9409 29.6081V32.2749H9.15258C6.05191 32.275 3.52934 29.7524 3.52934 26.6517V17.3913C3.52934 16.5122
        4.15523 15.7765 4.98469 15.6063C5.10316 15.582 5.22586 15.5693 5.35148 15.5693H54.6484C54.774 15.5693 54.8966 15.5821
        55.0151 15.6063C55.8447 15.7766 56.4704 16.5123 56.4704 17.3913V26.6516H56.4707Z"
        fill="currentColor"
      />
    </svg>
  );
};
